import React from 'react';
import { DatePicker, Input, InputNumber, Radio } from 'antd';
import dayjs from 'dayjs';
import BaseForm from '../../../../components/form/BaseForm';
import { ShiftMode } from '../../../../lib/api/settlementDateAdjustment';

type Props = {
  shiftMode: ShiftMode;
  deltaDays: number;
  targetBaseDate?: string;
  reason: string;
  onShiftModeChange: (mode: ShiftMode) => void;
  onDeltaDaysChange: (v: number) => void;
  onTargetBaseDateChange: (v?: string) => void;
  onReasonChange: (v: string) => void;
};

/**
 * 변경 조건 (이동 방식 + 사유) 입력 폼.
 *
 * 정산 리스트 페이지의 SettlementListSearchBox 안에서 쓰는 BaseForm(label/content)
 * 레이아웃을 그대로 따라 시각적 통일을 맞춘다.
 */
export const ShiftForm = ({
  shiftMode,
  deltaDays,
  targetBaseDate,
  reason,
  onShiftModeChange,
  onDeltaDaysChange,
  onTargetBaseDateChange,
  onReasonChange,
}: Props): React.JSX.Element => {
  return (
    <>
      <BaseForm
        required
        label="이동 방식"
        content={
          <Radio.Group value={shiftMode} onChange={(e) => onShiftModeChange(e.target.value as ShiftMode)}>
            <Radio value="delta">일수 가감 (+N일)</Radio>
            <Radio value="absolute">특정 날짜로 고정</Radio>
          </Radio.Group>
        }
      />

      {shiftMode === 'delta' ? (
        <BaseForm
          required
          label="이동 일수"
          content={
            <InputNumber
              min={-30}
              max={60}
              value={deltaDays}
              onChange={(v) => onDeltaDaysChange(v ?? 0)}
              addonAfter="일"
              style={{ width: 160 }}
            />
          }
        />
      ) : (
        <BaseForm
          required
          label="목표 정산 기준일"
          content={
            <DatePicker
              value={targetBaseDate ? dayjs(targetBaseDate) : null}
              onChange={(d) => onTargetBaseDateChange(d?.format('YYYY-MM-DD'))}
              style={{ width: 200 }}
            />
          }
        />
      )}

      <BaseForm
        required
        label="변경 사유"
        content={
          <Input.TextArea
            rows={2}
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            placeholder="변경 사유를 입력해주세요"
            maxLength={500}
            showCount
          />
        }
      />
    </>
  );
};
